import {MI} from "../init";
import {getRandomBoolean} from "../../framework/src/helpers";
import MadnesTween from "../libs/mi/MadnesTween";

const FIRE_SPEED = 60;

/**
 * @constructor
 * @param {GameConfig} gameConfig
 * @returns {GameAssets}
 */
export default function GameAssets(gameConfig) {

    /** @type {MadnesObject} */
    this._logo;

    /** @type {GameConfig} */
    this.gameConfig = gameConfig;

    /** @type {MadnesGroup} */
    this._fsShineGroupBack;

    /** @type {MadnesGroup} */
    this._fsShineGroupFront;

    /** @type {MadnesObject} */
    this.fsHazeLeft;
    /** @type {MadnesObject} */
    this.fsHazeRight;
    /** @type {MadnesObject} */
    this.fsShineLeft;
    /** @type {MadnesObject} */
    this.fsShineRight;


    /** @type {Object<string, MadnesObject>} */
    this.lightFrames = {};

    /** @type {Object<string, MadnesObject>} */
    this.fsSearch = {};

    /** @type {Object<string, MadnesTween>} */
    this.fsSearchTweens = {};

    /** @type {Object<string, MadnesObject>} */
    this.frameFires = {};

    /** @type {number} */
    this._firesScaleInTime = 100;

    /** @type {number} */
    this._firesScaleOutTime = 100;

    this._millAngle = 0;
    this._millBetweenAngle = 60;
    this._millVelocity = 0;
    /** @type {Object<string, MadnesObject>} */
    this._millAssets = {};

    /** @type {Array<Object<string,MadnesObject>>} */
    this._millBlades = [];

    /** @type {MadnesGroup} */
    this.millGroup;

    this._spinMillRender = this._spinMill.bind(this);

    /** @type {MadnesGraphics} */
    this.bigWinBlackScreen;

    /** @type {MadnesGroup} */
    this.multiReelsGroup;
    /** @type Array<MadnesObject> */
    this.multiReels = [];

    /** @type {MadnesGroup} */
    //this.multiCircleGroup;

    /** @type {MadnesObject} */
    this.multiCircleInner;
    /** @type {MadnesObject} */
    this.multiCircleOuter;

    /** @type {MadnesObject} */
    this.reelsBg;

    /** @type {MadnesObject} */
    this._reelsCoverLeft;
    /** @type {MadnesObject} */
    this._reelsCoverRight;
    /** @type {MadnesObject} */
    this._reelsCoverBottom;

    /** @type {MadnesGroup} */
    this.bigWinGroupSign;

    /** @type {MadnesGroup} */
    this.bigWinPreGroupDust;

    /** @type {MadnesGroup} */
    this.bigWinPostGroupDust;

    /** @type {MadnesGroup} */
    this.bigWinGroupText;

    /** @type {MadnesGroup} */
    this._fsInfoGroup;

    /** @type {MadnesObject} */
    this._fsInfo;

    /** @type {MadnesObject}*/
    this._fsInfoTxtCount;
    /** @type {MadnesObject}*/
    this._fsInfoTxtActual;

    /** @type {MadnesGroup} */
    this._alchemistGroup;

    /** @type {MadnesGroup} */
    this.fliesGroup;

//	/** @type {MadnesObject}*/
//	this._alchemistHand;

    /** @type {MadnesGroup} */
    this.bonusGroup;

    /** @type {MadnesGroup} */
    this.bonusParticlesGroup;
};

GameAssets.prototype.createLogo = function() {
    this._logo = MI.addImg(MI.getWi() / 2, 0, "reels_atlas").setFrameName("logo_reels");
    this._logo.setAnchor(0.5, 0);
};

GameAssets.prototype.hideLogo = function() {
    var _self = this;

    return new Promise(function(res) {
        MI.addTween().to(_self._logo, { 'alpha': 0 }, {
            'duration': 200,
            'callback': function() {
                _self._logo.setVisible(false);
                res();
            }
        });
    });
};

GameAssets.prototype.showLogo = function() {
    var _self = this;

    _self._logo.setVisible(true);

    return new Promise(function(res) {
        MI.addTween().to(_self._logo, { 'alpha': 1 }, {
            'duration': 200,
            'callback': res
        });
    });
};


GameAssets.prototype.createReelsBg = function() {
    this.reelsBg = MI.addImg(0, 0, "reels_background");
};

GameAssets.prototype.createReelCover = function() {
    this._reelsCoverLeft = MI.addImg(0, 0, "reels_cover_left");
    this._reelsCoverRight = MI.addImg(MI.getWi(), 0, "reels_cover_left").setScale(-1, 1).setAnchor(0, 0);
    this._reelsCoverBottom = MI.addImg(0, MI.getHe(), "reels_cover_low").setAnchor(0, 1);
};

GameAssets.prototype.visibleReelCover = function(bool) {
    this._reelsCoverLeft.setVisible(bool);
    this._reelsCoverRight.setVisible(bool);
    this._reelsCoverBottom.setVisible(bool);
};

GameAssets.prototype.createBigWinGroup = function() {
    this.bigWinBlackScreen = MI.addGraphics(0, 0);
    this.bigWinBlackScreen.beginFill(0x000000);
    this.bigWinBlackScreen.drawRectangle(50, 0, MI.getWi() - 50, MI.getHe() - 70);
    this.bigWinBlackScreen.setAlpha(0);
    this.bigWinBlackScreen.setVisible(false);

    this.bigWinPreGroupDust = MI.addGroup();
    this.bigWinGroupSign = MI.addGroup();
    this.bigWinPostGroupDust = MI.addGroup();

    this.bigWinGroupText = MI.addGroup();
    this.bigWinGroupShines = MI.addGroup();
};

GameAssets.prototype.createFreeSpinGroupBack = function() {
    this._fsShineGroupBack = MI.addGroup();
};

GameAssets.prototype.createFreeSpinGroupFront = function() {
    this._fsShineGroupFront = MI.addGroup();
};

GameAssets.prototype._createFreeSpinBg = function() {

    this.fsHazeLeft = MI.addImg(0, 0, "freespins_shine_back").setScale(3.2, 4).setBlend("ADD");//.setAlpha(0).setVisible(false);
    this._fsShineGroupBack.add(this.fsHazeLeft);
    this._fsShineGroupBack.setAlpha(0).setVisible(false);

    this.fsHazeRight = MI.addImg(MI.getWi(), 0, "freespins_shine_back").setScale(-3.2, 4).setBlend("ADD");//.setAlpha(0).setVisible(false);
    this._fsShineGroupBack.add(this.fsHazeRight);

    this.fsShineLeft = MI.addImg(0, 0, "freespins_shine_atlas").setScale(3, 3.1).setBlend("ADD");//.setAlpha(0).setVisible(false);
    this.fsShineLeft.createAnims();
    this.fsShineLeft.anims.add("shine", MI.generateFrameNames("freespins_shine_1_", 0, 35, "", 5));
    //this.fsShineLeft.anims.loop("shine");
    this._fsShineGroupFront.add(this.fsShineLeft);

    this.fsShineRight = MI.addImg(MI.getWi(), 0, "freespins_shine_atlas").setScale(-3, 3.1).setBlend("ADD");//.setAlpha(0).setVisible(false);
    this.fsShineRight.createAnims();
    this.fsShineRight.anims.add("shine", MI.generateFrameNames("freespins_shine_1_", 0, 35, "", 5));
    //this.fsShineRight.anims.loop("shine");
    this._fsShineGroupFront.add(this.fsShineRight);

    this._fsShineGroupFront.setAlpha(0).setVisible(false);
};

GameAssets.prototype.fadeInFreeSpin = function() {
    this._createFreeSpinBg();

    this._fsShineGroupBack.setVisible(true);
    this._fsShineGroupFront.setVisible(true);

    this.fsShineLeft.anims.loop("shine", 27);
    this.fsShineRight.anims.loop("shine", 27);

    MI.addTween().to(this._fsShineGroupBack, { 'alpha': 1 }, {
        'duration': 900
        //'delay': 1500,
        /*'callback': function() {
            cb();
        }*/
    });

    MI.addTween().to(this._fsShineGroupFront, { 'alpha': 1 }, {
        'duration': 900
        //'delay': 1500,
        //'callback': res
    });
};

GameAssets.prototype.fadeOutFreeSpin = function() {
    MI.addTween().to(this._fsShineGroupBack, { 'alpha': 0 }, {
        'duration': 550,
        'callback': function() {
            this._fsShineGroupBack.setVisible(true);
        }.bind(this)
    });

    MI.addTween().to(this._fsShineGroupFront, { 'alpha': 0 }, {
        'duration': 600,
        'callback': function() {
            this._fsShineGroupFront.setVisible(true);
            this.fsShineLeft.anims.loop("shine");
            this.fsShineRight.anims.loop("shine");
            this._destroyFreeSpinBg();
        }.bind(this)
    });
};

GameAssets.prototype._destroyFreeSpinBg = function() {
    this.fsHazeLeft.destroy();
    this.fsHazeRight.destroy();
    this.fsShineLeft.destroy();
    this.fsShineRight.destroy();
};

GameAssets.prototype.createFreeSpinSearch = function() {
    this.fsSearch['reel2'] = MI.addImg(MI.getWi() / 2, 342 + 10, "searching_atlas")
        .setAnchor(.5, .5).setScale(2.5, 2.56).setBlend("ADD").setVisible(false);
    this.fsSearch['reel2'].createAnims();
    this.fsSearch['reel2'].anims.add("search", MI.generateFrameNames("searching_", 0, 17, "", 5));

    this.fsSearch['reel4'] = MI.addImg(1280 - 180, 342 + 10, "searching_atlas")
        .setAnchor(.5, .5).setScale(2.5, 2.56).setBlend("ADD").setVisible(false);
    this.fsSearch['reel4'].createAnims();
    this.fsSearch['reel4'].anims.add("search", MI.generateFrameNames("searching_", 0, 17, "", 5));
};

/**
 * @param {number} reelPosX
 * @returns {undefined}
 */
GameAssets.prototype.fadeInFreeSpinSearch = function(reelPosX) {

    if(!this.fsSearch['reel' + reelPosX]) {
        return;
    }

    var obj = this.fsSearch['reel' + reelPosX];
    obj.setAlpha(0).setVisible(true);
    obj.anims.loop("search", 27);
    this.fsSearchTweens['reel' + reelPosX] = MI.addTween().to(obj, { 'alpha': 1 }, {
        'duration': 300
        //'delay': 100,
    });
};

/**
 * @param {number} reelPosX
 * @returns {undefined}
 */
GameAssets.prototype.fadeOutFreeSpinSearch = function(reelPosX) {

    if(!this.fsSearch['reel' + reelPosX]) {
        return;
    }

    var obj = this.fsSearch['reel' + reelPosX];
    this.fsSearchTweens['reel' + reelPosX] = MI.addTween().to(obj, { 'alpha': 0 }, {
        //'delay': 400,
        'duration': 300,
        'callback': function() {
            obj.anims.stop();
            obj.setAlpha(0).setVisible(true);
        }
    });
};

GameAssets.prototype.stopSearchTweens = function() {
    for(var i in this.fsSearchTweens) {
        this.fsSearchTweens[i].stop();
    }
};

GameAssets.prototype.fadeOutAllSearch = function() {
    this.fadeOutFreeSpinSearch(2);
    this.fadeOutFreeSpinSearch(4);
};

GameAssets.prototype.createLightFrames = function() {

    this.lightFrames['lightLeft1'] = MI.addImg(3, 0, "reels_atlas").setFrameName("light_right_1");
    this.lightFrames['lightLeft1'].setScale(-1, 1).setAnchor(1, 0).setVisible(false);

    this.lightFrames['lightLeft2'] = MI.addImg(0 + 2, 224 +8, "reels_atlas").setFrameName("light_right_2");
    this.lightFrames['lightLeft2'].setScale(-1, 1).setAnchor(1, 0).setVisible(false); //.setBlend("ADD").setTint(0xffd189);

    this.lightFrames['lightLeft3'] = MI.addImg(0 + 2, 430 + 14, "reels_atlas").setFrameName("light_right_3");
    this.lightFrames['lightLeft3'].setScale(-1, 1).setAnchor(1, 0).setVisible(false); //.setBlend("ADD").setTint(0xffcb79);

    this.lightFrames['lightBottom1'] = MI.addImg(70, 651, "reels_atlas").setFrameName("light_low_1").setVisible(false);;
    this.lightFrames['lightBottom2'] = MI.addImg(298, 651, "reels_atlas").setFrameName("light_low_2").setVisible(false);;
    this.lightFrames['lightBottom3'] = MI.addImg(526, 651, "reels_atlas").setFrameName("light_low_3").setVisible(false);;
    this.lightFrames['lightBottom4'] = MI.addImg(754, 651, "reels_atlas").setFrameName("light_low_4").setVisible(false);;
    this.lightFrames['lightBottom5'] = MI.addImg(982, 651, "reels_atlas").setFrameName("light_low_5").setVisible(false);;

    this.lightFrames['lightRight1'] = MI.addImg(MI.getWi() - 3, 0, "reels_atlas").setFrameName("light_right_1");
    this.lightFrames['lightRight1'].setAnchor(1, 0).setVisible(false);;//.setBlend("ADD");

    this.lightFrames['lightRight2'] = MI.addImg(MI.getWi() - 2, 224 + 8, "reels_atlas").setFrameName("light_right_2");
    this.lightFrames['lightRight2'].setAnchor(1, 0).setVisible(false);;

    this.lightFrames['lightRight3'] = MI.addImg(MI.getWi() - 2, 430 + 14, "reels_atlas").setFrameName("light_right_3");
    this.lightFrames['lightRight3'].setAnchor(1, 0).setVisible(false);;
};

GameAssets.prototype.hideLightFramesFs = function() {
    var _self = this;


    for(var i = 1; i <= 3; i++) {

        (function(i) {
            MI.addTween().to(_self.lightFrames['lightLeft' + i], { 'alpha': 0 }, {
                'delay': 600,
                'duration': 300,
                'callback': function() {
                    _self.lightFrames['lightLeft' + i].setVisible(true);
                }
            });

            MI.addTween().to(_self.lightFrames['lightRight' + i], { 'alpha': 0 }, {
                'delay': 600,
                'duration': 300,
                'callback': function() {
                    _self.lightFrames['lightRight' + i].setVisible(true);
                }
            });
        } (i));
    }


    /*this.visibleLightFrames(false);
    for(var i = 1; i <= 5; i++) {
        this.lightFrames['lightBottom' + i].setVisible(true);
    }*/
};

GameAssets.prototype.showLightFramesFs = function() {

    var _self = this;


    for(var i = 1; i <= 3; i++) {

        _self.lightFrames['lightLeft' + i].setVisible(true);
        _self.lightFrames['lightRight' + i].setVisible(true);

        (function(i) {
            MI.addTween().to(_self.lightFrames['lightLeft' + i], { 'alpha': 1 }, {
                'duration': 400
            });

            MI.addTween().to(_self.lightFrames['lightRight' + i], { 'alpha': 1 }, {
                'duration': 400
            });
        } (i));
    }

    //this.visibleLightFrames(true);
};

GameAssets.prototype.visibleLightFrames = function(bool) {
    for(var i in this.lightFrames) {
        this.lightFrames[i].setVisible(bool);
    }
};

/**
 * @param {SpinReels} spinReels
 * @returns {undefined}
 */
GameAssets.prototype.colorizeAllFrames = function(spinReels) {
    for(var i = 0; i < spinReels.getReels().length; i++) {
        this.colorizeReelFrames(spinReels.getReel(i));
    }
};

/**
 * @param {SpinReel} reel
 * @param {number=} forceColor
 * @returns {undefined}
 */
GameAssets.prototype.colorizeReelFrames = function(reel, forceColor) {
    if(reel.id === 0) {
        for(var i = 0; i < 3; i++) {
            this._fadeInColorFrame('lightLeft' + (i + 1), forceColor ? forceColor : reel.reelSymbols[i].getShineColor());
        }
        this._fadeInColorFrame('lightBottom1', forceColor ? forceColor : reel.reelSymbols[2].getShineColor());
    }

    if(reel.id === 1) {
        this._fadeInColorFrame('lightBottom2', forceColor ? forceColor : reel.reelSymbols[2].getShineColor());
    }

    if(reel.id === 2) {
        this._fadeInColorFrame('lightBottom3', forceColor ? forceColor : reel.reelSymbols[2].getShineColor());
    }

    if(reel.id === 3) {
        this._fadeInColorFrame('lightBottom4', forceColor ? forceColor : reel.reelSymbols[2].getShineColor());
    }

    if(reel.id === 4) {
        for(var i = 0; i < 3; i++) {
            this._fadeInColorFrame('lightRight' + (i + 1), forceColor ? forceColor : reel.reelSymbols[i].getShineColor());
        }
        this._fadeInColorFrame('lightBottom5', forceColor ? forceColor : reel.reelSymbols[2].getShineColor());
    }
};

/**
 * @param {AbstractSymbol} symbol
 * @param {number=} delay
 */
GameAssets.prototype.colorizeReelFramesBySymbol = function(symbol, delay) {

    delay = delay ? delay : 0;

    setTimeout(function() {

        var reelX = symbol.getReelX();
        var reelY = symbol.getReelY();

        if(reelX === 0 || reelX === 4) {
            this._fadeInColorFrame('lightLeft' + (reelY + 1), symbol.getShineColor());
        }

        if(reelY === 2) {
            this._fadeInColorFrame('lightBottom' + (reelX + 1), symbol.getShineColor());
        }

    }.bind(this), delay);
};

/**
 * @private
 * @param {string} frameName
 * @param {number} color
 * @returns {undefined}
 */
GameAssets.prototype._fadeInColorFrame = function(frameName, color) {

    if(this.lightFrames[frameName].getTint() === color) {
        return;
    }

    this.lightFrames[frameName].setAlpha(0).setVisible(true).setBlend("ADD").setTint(color);
    MI.addTween().to(this.lightFrames[frameName], { 'alpha': 1 }, { 'duration': 200 });
};

/**
 * @param {SpinReel} reel
 * @returns {undefined}
 */
GameAssets.prototype.fadeOutColorFrames = function(reel) {

    if(reel.id === 0) {
        for(var i = 0; i < 3; i++) {
            this._fadeOutColorFrame('lightLeft' + (i + 1));
        };

        this._fadeOutColorFrame('lightBottom1');
    }

    if(reel.id === 1) {
        this._fadeOutColorFrame('lightBottom2');
    }

    if(reel.id === 2) {
        this._fadeOutColorFrame('lightBottom3');
    }

    if(reel.id === 3) {
        this._fadeOutColorFrame('lightBottom4');
    }

    if(reel.id === 4) {
        for(var i = 0; i < 3; i++) {
            this._fadeOutColorFrame('lightRight' + (i + 1));
        }
        this._fadeOutColorFrame('lightBottom5');
    }
};

/**
 * @private
 * @param {string} frameName
 * @returns {undefined}
 */
GameAssets.prototype._fadeOutColorFrame = function(frameName) {
    MI.addTween().to(this.lightFrames[frameName], {
        'alpha': 0
    }, {
        'duration': 200,
        'callback': function() {
            this.lightFrames[frameName].setTint(0x000000);
            this.lightFrames[frameName].setVisible(false);
        }.bind(this)
    });
};

GameAssets.prototype.createFrameFires = function() {

    this.frameFires["leftTop"] = this._createFlame(-12, 150, 0);
    this.frameFires["leftCenter"] = this._createFlame(-12, 350, 0);
    this.frameFires["leftBottom"] = this._createFlame(-12, 570, 0);

    this.frameFires["rigthTop"] = this._createFlame(MI.getWi() + 25, 150, 1);
    this.frameFires["rigthCenter"] = this._createFlame(MI.getWi() + 25, 350, 1);
    this.frameFires["rigthBottom"] = this._createFlame(MI.getWi() + 25, 570, 1);
};

GameAssets.prototype._createFlame = function(x, y, anchorX) {

    var bg = MI.addImg(x, y, "reels_atlas").setFrameName("reels_flame_bg").setBlend("ADD").setAnchor(anchorX, 1);

    //var flame = MI.addImg(x, y, "reels_flame_atlas").setBlend("ADD").setAnchor(anchorX, 1);
    var flame = MI.addImg(x, y, "reels_atlas").setFrameName("flame_00000").setBlend("ADD").setAnchor(anchorX, 1);
    flame.createAnims();
    flame.anims.add("fire", MI.generateFrameNames("flame_", 0, 29, "", 5));

    var winBg = MI.addImg(x, y + 30, "reels_atlas");
    winBg.setFrameName("reels_flame_win_bg");
    winBg.setBlend("ADD");
    winBg.setAnchor(anchorX, 1);
    winBg.kill();

    var winFlame = MI.addImg(x, y + 24, "reels_atlas").setFrameName("flame_00000").setBlend("ADD").setAnchor(anchorX, 1);
    winFlame.createAnims();
    winFlame.anims.add("fire", MI.generateFrameNames("flame_", 0, 29, "", 5));
    winFlame.setScale(1, 2);
    winFlame.setAlpha(0);
    winFlame.kill();

    return {
        'bg': bg,
        'flame': flame,
        'winBg': winBg,
        'winFlame': winFlame
    };
};

GameAssets.prototype.visibleFrameFires = function(bool) {
    for(var i in this.frameFires) {

        if(bool) {
            this.frameFires[i]['flame'].anims.loop("fire", FIRE_SPEED);
        } else {
            this.frameFires[i]['flame'].anims.stop();
        }


        this.frameFires[i]['bg'].setVisible(bool);
        this.frameFires[i]['winBg'].setVisible(bool).kill();
        this.frameFires[i]['flame'].setVisible(bool);
        this.frameFires[i]['winFlame'].setVisible(bool).kill();
    }
};

GameAssets.prototype.frameFiresScaleIn = function() {

    for(var i in this.frameFires) {

        this.frameFires[i]["winBg"].revive();
        this.frameFires[i]["winBg"].setAlpha(0);

        this.frameFires[i]["winFlame"].revive();
        this.frameFires[i]["winFlame"].setAlpha(0);
        this.frameFires[i]["winFlame"].anims.loop("fire", FIRE_SPEED);

        MI.addTween().to(this.frameFires[i]["winBg"], { 'alpha': 1 }, {
            'duration': this._firesScaleInTime
        });

        MI.addTween().to(this.frameFires[i]["winFlame"], { 'alpha': 1 }, {
            'duration': this._firesScaleInTime
        });
    }
};

GameAssets.prototype.frameFiresScaleOut = function () {
    var _self = this;

    for(var i in this.frameFires) {

        (function(fireFrame) {

            MI.addTween().to(fireFrame["winBg"], { 'alpha': 0 }, {
                'duration': _self._firesScaleOutTime,
                'callback': function() {
                    fireFrame["winBg"].kill();
                }
            });

            MI.addTween().to(fireFrame["winFlame"], { 'alpha': 0 }, {
                'duration': _self._firesScaleOutTime,
                'callback': function() {
                    fireFrame["winFlame"].anims.stop();
                    fireFrame["winFlame"].kill();
                }
            });

        } (this.frameFires[i]));
    }
};

GameAssets.prototype.createMillGroup = function() {
    this.millGroup = MI.addGroup();
};

/**
 * @param {number} x
 * @param {number} y
 * @param {boolean} preinfo
 * @returns {MadnesObject}
 */
GameAssets.prototype.createMill = function(x, y, preinfo) {

    var visible = !preinfo;

    this._millAngle = 0;
    this._millVelocity = 0;

    this._millAssets["base"] = MI.addImg(x, y, "mill_atlas")
        .setFrameName("shuffle_back").setAnchor(0.5, 0);

    if(preinfo) {
        this._millAssets["base"].setFrameName("none");
    }

    this._millAssets["baseShine"] = MI.addImg(0, 0 + 324, "mill_atlas")
        .setFrameName("shuffle_back_shine").setAnchor(0.5, 0.5).setAlpha(0).setVisible(visible);
    this._millAssets["base"].addChild(this._millAssets["baseShine"]);

    this._createMillBlades(/*preinfo*/);

    this._millAssets["center"] = MI.addImg(0, 50, "mill_atlas")
        .setFrameName("shuffle_center").setAnchor(0.5, 0.5);
    this._millAssets["base"].addChild(this._millAssets["center"]);

    this._millAssets["dotCenter"] = MI.addImg(0, 50, "mill_atlas")
        .setFrameName("shuffle_wheel_center_shine").setAnchor(0.5, 0.5).setAlpha(0).setVisible(visible);
    this._millAssets["base"].addChild(this._millAssets["dotCenter"]);

    return this._millAssets["base"];

    //this._millFadeInLight();
    //this.startSpinMill();
};

GameAssets.prototype._createMillBlades = function() {

    for(var i = 0; i < 6; i++) {

        this._millBlades[i] = {};

        this._millBlades[i]['blade_blur'] = MI.addImg(0, 50, "blade_blur_atlas")
            .setFrameName("blade_blur").setAnchor(1, 0.5).setAngle(this._millBetweenAngle * i).setVisible(false).setAlpha(0);
        this._millAssets["base"].addChild(this._millBlades[i]['blade_blur']);

        this._millBlades[i]['dot_blur'] = MI.addImg(0, 50, "blade_blur_atlas")
            .setFrameName("blade_dot_blur").setAnchor(1, 0.5).setScale(0.9, 0.9)
            .setAngle(this._millBetweenAngle * i).setVisible(false).setAlpha(0);
        this._millAssets["base"].addChild(this._millBlades[i]['dot_blur']);


        this._millBlades[i]['blade_wrapper'] = MI.addImg(0, 50, "mill_atlas")
            .setAngle(this._millBetweenAngle * i).setAnchor(1, 0.5).setScale(0.9, 0.9);
        this._millAssets["base"].addChild(this._millBlades[i]['blade_wrapper']);

        this._millBlades[i]['blade'] = MI.addImg(0, 0, "blade_atlas").setFrameName("blade").setAnchor(1, 0.5);
        this._millBlades[i]['blade_wrapper'].addChild(this._millBlades[i]['blade']);

        this._millBlades[i]['shine'] = MI.addImg(-345, 100, "blade_atlas")
            .setFrameName("blade_shine").setAnchor(0.5, 0).setScale(1, -1).setAngle(15).setBlend("ADD").setVisible(false).setAlpha(0);
        this._millBlades[i]['blade_wrapper'].addChild(this._millBlades[i]['shine']);


        this._millBlades[i]['dot'] = MI.addImg(0, 50, "blade_atlas")
            .setFrameName("blade_dot").setAnchor(1, 0.5).setScale(0.9, 0.9).setAngle(this._millBetweenAngle * i).setAlpha(0);//.setVisible(false);
        this._millAssets["base"].addChild(this._millBlades[i]['dot']);
    }

};

GameAssets.prototype._spinMill = function() {

    this._millAngle -= this._millVelocity;

    for(var i = 0; i < this._millBlades.length; i++) {
        this._millBlades[i]["blade_wrapper"].setAngle(this._millAngle + this._millBetweenAngle * i);
        this._millBlades[i]["dot"].setAngle(this._millAngle + this._millBetweenAngle * i);
        this._millBlades[i]["blade_blur"].setAngle(this._millAngle + this._millBetweenAngle * i);
        this._millBlades[i]["dot_blur"].setAngle(this._millAngle + this._millBetweenAngle * i);
    }
};

GameAssets.prototype.startSpinMill = function() {
    this._millVelocity = 1;
    MI.addToRender(this._spinMillRender);
};

GameAssets.prototype.stopSpinMill = function() {
    this._millVelocity = 0;
    MI.removeFromRender(this._spinMillRender);
};

/**
 * @returns {Promise}
 */
GameAssets.prototype.moveInMill = function() {

    return new Promise(function(res) {

        //millGroup.setVisible(true);

        MI.addTween().to(this._millAssets["base"], { 'y': MI.getHe() / 2 - 80 }, {
            'duration': 2000,
            'easing': MadnesTween.getEasing("back_out"),
            'callback': function() {
                //console.log('rt');
                //console.log(madnes_objects[millGroup.name].y);
                //madnes_objects[millGroup.name].visible = true;
                res();
            }
        });
    }.bind(this));
};

/**
 * @param {MadnesGroup} millGroup
 * @returns {Promise}
 */
GameAssets.prototype.moveOutMill = function(millGroup) {

    return new Promise(function(res) {

        MI.addTween().to(this._millAssets["base"], { 'y': MI.getHe() + 170 }, {
            'duration': 2000,
            'callback': res
        });
    }.bind(this));
};

GameAssets.prototype.millFadeInLight = function() {

    this._millAssets["baseShine"].setVisible(true);
    this._millAssets["dotCenter"].setVisible(true);

    MI.addTween().to(this._millAssets["baseShine"], { 'alpha': 1 }, {
        'duration': 600
    });

    MI.addTween().to(this._millAssets["dotCenter"], { 'alpha': 1 }, {
        'duration': 600
    });

    for(var i = 0; i < this._millBlades.length; i++) {

        this._millBlades[i]["dot"].setVisible(true);

        MI.addTween().to(this._millBlades[i]["dot"], { 'alpha': 1 }, {
            'duration': 600
        });
    }

    return new Promise(function(res) {
        setTimeout(res, 1000);
    }.bind(this));
};

/**
 * @param {number} to
 * @param {number=} duration
 * @returns {undefined}
 */
GameAssets.prototype.millSpeedUp = function(to, duration) {

    duration = typeof duration === 'undefined' ? 2000 : duration;

    for(var i = 0; i < this._millBlades.length; i++) {
        this._millBlades[i]['shine'].setVisible(true);
        this._millBlades[i]['blade_blur'].setVisible(true);
        this._millBlades[i]['dot_blur'].setVisible(true);
        this._millBlades[i]['dot_blur'].setAlpha(0);
    }

    var obj = { 'velocity': this._millVelocity };

    MI.addTween().to(obj, { "velocity": to }, {
        "update": function(t, perc) {

            this._millVelocity = obj['velocity'];

            for(var i = 0; i < this._millBlades.length; i++) {
                this._millBlades[i]['shine'].setAlpha(perc);
                this._millBlades[i]['blade_blur'].setAlpha(perc);
                this._millBlades[i]['dot_blur'].setAlpha(perc);
                this._millBlades[i]['blade'].setAlpha(1.5 - perc);
                this._millBlades[i]['dot'].setAlpha(1 - perc);
            }

        }.bind(this),
        "duration": duration,
        "callback": function() {
            for(var i = 0; i < this._millBlades.length; i++) {
                this._millBlades[i]['shine'].setAlpha(1);
                this._millBlades[i]['blade_blur'].setAlpha(1);
                this._millBlades[i]['blade'].setAlpha(0);
                this._millBlades[i]['dot'].setAlpha(0);
            }
        }.bind(this)
    });
};

/**
 * @param {MadnesObject} mill
 * @returns {undefined}
 */
GameAssets.prototype.destroyMill = function(mill) {

    for(var k in this._millAssets) {
        this._millAssets[k].destroy();
    }

    this._millAssets = {};

    mill.destroy();

    /*for(var i = 0; i < this._millBlades.length; i++) {

        for(var k in this._millBlades[i]) {
            this._millBlades[i][k].destroy();
        }
    }*/

    this._millBlades = [];
};

GameAssets.prototype.createMultiReelsGroup = function() {
    this.multiReelsGroup = MI.addGroup();
};

GameAssets.prototype.destroyMultiReelsGroup = function() {

    if(!this.multiReelsGroup) {
        return;
    }

    this.multiReelsGroup.destroy();
    this.multiReelsGroup = null;
};

GameAssets.prototype.createMultiReels = function(multi) {

    for(var i = 0; i < multi; i++) {
        this.multiReels[i] = MI.addImg(this.gameConfig.reelsPositions[i]['x'], 0, "multiplier_reel")
            .setAnchor(0.5, 0).setBlend("ADD").setScale(2, 2).setAlpha(1).setVisible(false);
        this.multiReelsGroup.add(this.multiReels[i]);
    }
};

GameAssets.prototype.destroyMultiReels = function() {

    for(var i = 0; i < this.multiReels.length; i++) {
        this.multiReels[i].destroy();
    }

    this.multiReels = [];
};

GameAssets.prototype.fadeInOutMultiReels = function() {

    this.multiReelsGroup.setAlpha(0).setVisible(true);

    MI.addTween().to(this.multiReelsGroup, { 'alpha': 0.9 }, {
        'duration': 400,
        'callback': function() {

            MI.addTween().to(this.multiReelsGroup, { 'alpha': 0.8 }, {
                'duration': 400,
                'yoyo': true,
                'count': 3,
                'callback': function() {

                    MI.addTween().to(this.multiReelsGroup, { 'alpha': 0 }, {
                        'duration': 400,
                        'callback': function() {
                            this.multiReelsGroup.setVisible(false);
                        }.bind(this)
                    });

                }.bind(this)
            });

        }.bind(this)
    });
};

GameAssets.prototype.createMultiCircle = function(x, y) {
    this.multiCircleInner = MI.addImg(x, y, "multiplier_shine")
        .setAlpha(0).setAnchor(0.5, 0.5).setBlend("ADD").setScale(0.2 * 0.74, 0.2 * 0.74).setTint(0xacf0ff);
    this.multiCircleOuter = MI.addImg(x, y, "multiplier_shine")
        .setAlpha(0).setAnchor(0.5, 0.5).setBlend("ADD").setScale(0.2, 0.2).setTint(0x00d2ff);
};

GameAssets.prototype.destroyMultiCircle = function() {
    this.multiCircleInner.destroy();
    this.multiCircleOuter.destroy();
};

GameAssets.prototype.multiCircleFadeIn = function() {

    MI.addTween().to(this.multiCircleInner, { 'alpha': 1 }, {
        'duration': 800
    });

    MI.addTween().to(this.multiCircleOuter, { 'alpha': 1 }, {
        'duration': 800
    });

    MI.addTween().to(this.multiCircleInner, { 'x': 0.74, 'y': 0.74 }, {
        'scale': true,
        'duration': 800
    });

    MI.addTween().to(this.multiCircleOuter, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 800
    });


    MI.addTween().to(this.multiCircleInner, { 'angle': 85 }, {
        'duration': 4500
    });

    MI.addTween().to(this.multiCircleOuter, { 'angle': -85 }, {
        'duration': 4500
    });

    MI.createTimer().add(function() {

        MI.addTween().to(this.multiCircleInner, { 'alpha': 0 }, {
            'duration': 500
        });

        MI.addTween().to(this.multiCircleOuter, { 'alpha': 0 }, {
            'duration': 500
        });

    }.bind(this), 800 + 3200);
};

GameAssets.prototype.playMultipler = function(multi) {
    //this.destroyMultiReelsGroup();
    //this.createMultiReelsGroup();

    return new Promise(function(res) {

        var x = MI.getWi() / 2;
        var y = this.gameConfig.reelsPositions[0]['y'] + this.gameConfig.symbolHeight * 2;
        var frameName = multi + "x_big";

        if(multi === 3) {
            x = this.gameConfig.reelsPositions[1]['x'];
        }

        if(multi === 4) {
            var diff = this.gameConfig.reelsPositions[2]['x'] - this.gameConfig.reelsPositions[1]['x'];
            x = this.gameConfig.reelsPositions[1]['x'] + diff / 2;
        }

        this.createMultiReels(multi);
        this.createMultiCircle(x, y);

        for(var i = 0; i < this.multiReels.length; i++) {
            this.multiReels[i].setVisible(true);
        }

        var multiText = MI.addImg(x, y, "multi_big_atlas").setFrameName(frameName)
            .setAlpha(0).setAnchor(0.5, 0.5);

        this.fadeInOutMultiReels();
        this.multiCircleFadeIn();

        MI.addTween().to(multiText, { 'alpha': 1 }, {
            'duration': 400,
            'delay': 500,
            'callback': function() {
                MI.addTween().to(multiText, { 'x': 0.9, 'y': 0.9 }, {
                    'scale': true,
                    'duration': 400,
                    'yoyo': true,
                    'count': 3,
                    'callback': function() {
                        MI.addTween().to(multiText, { 'x': 0.9, 'y': 0.9 }, {
                            'scale': true,
                            'duration': 400
                        });

                        MI.addTween().to(multiText, { 'alpha': 0 }, {
                            'duration': 450,
                            'callback': function() {
                                multiText.destroy();
                                this.destroyMultiReels();
                                this.destroyMultiCircle();
                                res();
                            }.bind(this)
                        });
                    }.bind(this)
                });
            }.bind(this)
        });
    }.bind(this));
};

/**
 * @param {number} x
 * @param {number} y
 * @param {number} count 5
 * @param {number} radius 60
 * @param {number} color 0x4cd8eb
 * @param {number} delay
 * @param {MadnesGroup=} group
 * @param {MadnesGroup=} group2
 */
GameAssets.prototype.dust = function(x, y, count, radius, color, delay, group, group2) {

    for(var i = 0; i < count; i++) {

        setTimeout(function() {

            var rx = x;
            var ry = y;

            if(radius) {
                var rand = MI.getCircleRandPoint(radius);
                rx = x + rand['x'];
                ry = y + rand['y'];
            }

            var dust = MI.addImg(rx, ry, "dust_atlas")
                .setBlend("ADD").setAnchor(0.5, 0.5).setScale(2.5, 2.5).setTint(color);

            if(group2 && group)
            {
                if(getRandomBoolean()) {
                    group.add(dust);
                } else
                {
                    group2.add(dust);
                }
            } else if(group)
            {
                group.add(dust);
            }

            dust.createAnims();
            dust.anims.add("dust", MI.generateFrameNames("dust_", 1, 26, "", 5));
            (function(dust) {
                dust.anims.addOnComplete(function() {
                    dust.destroy();
                });
            } (dust));

            dust.anims.play("dust");
        }, i * delay);
    }
};

GameAssets.prototype.createFsInfoGroup = function() {
    this._fsInfoGroup = MI.addGroup();
};

GameAssets.prototype.createFsInfo = function() {
    this._fsInfo = MI.addImg(MI.getWi() / 2, 0, "freespins_info");
    this._fsInfo.setAnchor(0.5, 0);
    this._fsInfo.setVisible(false);
    this._fsInfo.setScale(0.3, 1);
    this._fsInfo.setAlpha(0);
    this._fsInfoGroup.add(this._fsInfo);

    this._fsInfoTxtCount = MI.addBitmapText("font_normal_win", 122, -15, "0/0", 60);
    this._fsInfoTxtCount.setAnchor(0.5, 0);
    this._fsInfo.addChild(this._fsInfoTxtCount);
};

GameAssets.prototype.playFsInfoAnim = function(count, all) {
    return new Promise(function(res) {

        this.setFsInfo(count, all);

        this._fsInfo.setVisible(true);
        MI.addTween().to(this._fsInfo, { 'x': 1 }, {
            'scale': true,
            'easing': MadnesTween.getEasing("back_out"),
            'duration': 600,
            'callback': res
        });

        MI.addTween().to(this._fsInfo, { 'alpha': 1 }, {
            'duration': 600
        });
    }.bind(this));
};

/** @returns {Promise} */
GameAssets.prototype.hideFsInfoAnim = function() {
    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._fsInfo, { 'alpha': 0 }, {
            'duration': 600,
            'callback': function() {
                _self.destroyFsInfo();
                res();
            }
        });
    });
};

/**
 * @param {number} from
 * @param {number} to
 * @param {number} actual
 * @param {Game} game
 * @returns {Promise}
 */
GameAssets.prototype.countFsInfo = function(from, to, actual, game) {

    return new Promise(function(res) {
        var obj = { 'count': from };
        var lastCount = 0;


        MI.addTween().to(obj, { 'count': to }, {
            'duration': 1500,
            'update': function() {
                var count = obj['count'] | 0;
                if(lastCount !== count) {
                    game && game.sounds["bonus_FreeSpins_Counter"].play();
                }
                lastCount = count;

                this._fsInfoTxtCount.setText(actual + "/" + count);
            }.bind(this),
            'callback': function() {
                game && game.sounds["bonus_FreeSpins_Counter"].play();
                this._fsInfoTxtCount.setText(actual + "/" + to);
                res();
            }.bind(this)
        });
    }.bind(this));
};

/**
 * @param {number} count
 * @param {number} all
 */
GameAssets.prototype.setFsInfo = function(count, all) {
    this._fsInfoTxtCount.setText(count + "/" + all);
};

GameAssets.prototype.destroyFsInfo = function() {
    this._fsInfoTxtCount.destroy();
    this._fsInfo.destroy();

    this._fsInfoTxtCount = null;
    this._fsInfo = null;
};

//GameAssets.prototype.multiCircleFadeIn

GameAssets.prototype.createFliesGroup = function() {
    this.fliesGroup = MI.addGroup();
};

GameAssets.prototype.createAlchemistGroup = function() {
    this._alchemistGroup = MI.addGroup();
};

/**
 * @returns {MadnesGroup}
 */
GameAssets.prototype.getAlchemistGroup = function() {
    return this._alchemistGroup;
};

GameAssets.prototype.createBonusGroup = function() {
    this.bonusGroup = MI.addGroup("bonus_group");
};

GameAssets.prototype.createBonusParticlesGroup = function() {
    this.bonusParticlesGroup = MI.addGroup("bonus_particles_group");
};


///**
// * @constructor
// * @returns {undefined}
// */
//function MillBlade() {
//
//};
//
////MillBlade.prototype.